import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import VideoDescription from "./../Components/description/VideoDescription";
import RelatedVideoList from "./../Components/List/RelatedVideoList";
import Player from "./../Components/Player/Player";
import { fetchVideo } from "./../features/video/videoSlice";

const Video = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { video, isLoading, isError, error } = useSelector((state) => state.video);
  const { link, title, tags } = video;
  useEffect(() => {
    dispatch(fetchVideo(id));
  }, [dispatch, id]);
  return (
    <section className='pt-6 pb-20'>
      <div className='mx-auto max-w-7xl px-2 pb-20 min-h-[400px]'>
        {isLoading && <div className='col-span-12'>Loading...</div>}
        {!isLoading && !isError && !video?.id ? <div className='col-span-12'>No video Found</div> : null}
        {!isLoading && !isError && video?.id ? (
          <div className='grid grid-cols-3 gap-2 lg:gap-8'>
            <div className='col-span-full w-full space-y-8 lg:col-span-2'>
              <Player link={link} title={title} />
              <VideoDescription video={video} />
            </div>
            <RelatedVideoList currentVideoId={id} tags={tags} />
          </div>
        ) : null}
        {isError && <div className='col-span-12'>{error}</div>}
      </div>
    </section>
  );
};

export default Video;
